export default {
  label: "User Management",
};
